import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// import HomePage from "./ExcellentHome";
import "./index.css";
import "./styles/yamaha-theme.css";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { HelmetProvider } from "react-helmet-async";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);